/**
 * Index View
 */
class IndexView extends AbstractProductsView {

	constructor(presenter) {

		super(presenter, "#product-cards-wrapper", "div.product-card");

		/*
		 * Listeners
		 */

	}

	/*
	 * Actions
	 */

	/*
	 * Getters and Setters
	 */

}